import { getLabel } from '../../../../utils/util';

export interface IRequiredLbl {
  required?: boolean;
  isFormReadonly?: boolean;
}

const RequiredLbl = ({
  required = false,
  isFormReadonly = false,
}: IRequiredLbl): JSX.Element | null => {
  return required && !isFormReadonly ? (
    <abbr className="required" title={getLabel('msgReqField').text}>
      *
    </abbr>
  ) : null;
};

export default RequiredLbl;
